import axios from 'axios';

export const cultureAsync = async () => {
  const res = await axios({
    url: 'api/user/culture',
    method: 'GET',
  });
  return res.data;
};

export const gsModuleActiveAsync = async () =>
  // const res = await axios({
  //   url: `api/user/culture`,
  //   method: "GET",
  // });
  false;
